import { useContext } from 'react';
import { OptionsContext } from '~/context/OptionsProvider';

export function useOptions() {
  const options = useContext(OptionsContext);

  if (!options) {
    throw new Error('useOptions must be used within an OptionsProvider');
  }

  return options;
}
